import React, { useEffect, useState } from 'react';
import { curveStep } from 'd3';
import MetricsGraphicsWrapper from 'screens/shared/metrics-graphics-wrapper';

const defaultConfig = {
  chartDimensions: {
    full_width: false,
    bottom: 30,
    width: 400,
    height: 200,
    left: 40,
    top: 30,
  },

  chartConfig: {
    decimals: 2,
    area: [true],
    buffer: 0,
    colors: ['#003D8F'],
    y_rollover_format: (dataPoint) => parseFloat(dataPoint.value).toFixed(2),
    interpolate: curveStep,
  },
};

const getGraphConfig = (props, data) => {
  const { params } = props;

  return {
    ...defaultConfig.chartConfig,
    ...defaultConfig.chartDimensions,
    ...params,
    data,
  };
};

export default (fetchAction, eventBus) => (props) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const handler = () => {
      fetchAction(props.fetchParams || {}).then(setData).catch(console.error);
    };

    let { refreshInterval } = props;
    if (typeof refreshInterval === 'undefined') {
      refreshInterval = 10000;
    }

    let intervalCleaner;
    if (refreshInterval > 1000) {
      intervalCleaner = setInterval(handler, refreshInterval);
    }
    handler();

    const subscription = eventBus.on('refresh', handler);

    return () => {
      clearInterval(intervalCleaner);
      subscription();
    };
  }, [props]);

  return (
    <div>
      <MetricsGraphicsWrapper
        params={getGraphConfig(props, data)}
      />
    </div>
  );
};
